// Vue-direktivet v-med-aktuell-sida-detektering kan användas på a-taggar för att få klassen "-aktuell-sida" satt, respektive länken disabled, om href korresponderar med aktuell sida (dess pathname endast!).

import Vue from 'vue';


const directive = {

	// called only once, when the directive is first bound to the element. This is where you can do one-time setup work.
	bind(el, binding, vnode) {
		//console.log('id=' + vnode.context._self._uid + ' : BIND, value = ' + binding.value);



		// Q&D SSO-specifik (!) fix för att betrakta även "/" och "/oversikt/{sid-id}" som "/oversikt":
		// Todo: Detta ska lösas snyggare sen. Den behöver ev även hantera andra sidors path-attribut (path-segment 2–n)!
		let locationPathname = location.pathname;

		if (locationPathname === '/'
			|| locationPathname.startsWith('/oversikt/'))
		{
			locationPathname = '/oversikt';
		}




		if (el.tagName === 'A' &&
			location.host + locationPathname === el.host + el.pathname)
		{
			// Om aktuell sidas URL (endast pathname) är densamma som denna länks href:
			el.classList.add('-aktuell-sida');
			el.setAttribute('disabled', '');
		}
	},
};


const registerDirectiveGlobally = function () {
	Vue.directive('med-aktuell-sida-detektering', directive);
};


const euiMedAktuellSidaDetektering = {
	// Properties:
	directive,

	// Methods:
	registerDirectiveGlobally,
};

export default euiMedAktuellSidaDetektering;
